var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"fecha"},[_c('p',[_vm._v(_vm._s(_vm.subTitulo7)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }